import type { MiSpec } from './schema';
import { miFromForm } from './spec';

function looksLikeModelInstanceSpec(input: unknown): input is MiSpec {
  if (!input || typeof input !== 'object') return false;
  const obj = input as Record<string, unknown>;
  return Boolean(obj.headGroupSpec || (obj.model && obj.runtime));
}

/** SKU preset（扁平表单或完整 MiSpec）规范化后再 parse */
export function normalizeMiPresetToSpec(data: unknown): MiSpec {
  if (looksLikeModelInstanceSpec(data)) {
    return data;
  }
  const raw = data && typeof data === 'object' ? (data as Record<string, unknown>) : {};
  return miFromForm(raw, {}, { elevateSharedEnvAndService: true });
}

export const miMigrations: Record<number, (data: unknown) => MiSpec> = {
  1: normalizeMiPresetToSpec,
  2: normalizeMiPresetToSpec,
};
